import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  homeUrl: string = '/';

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const fromUrl = this.route.snapshot.queryParams['from'] || '';
    const parts = fromUrl.split('/').filter((p: string) => p !== '');
    if (parts.length >= 1) {
      this.homeUrl = '/' + parts[0];
    }
  }
}
